/*
 * Composition root da listagem de usuários operativa.
 * Sem lógica de negócio aqui — apenas orquestra hook e componentes.
 */
import React from "react";
import * as MUI from "@mui/material";
import * as Icon from "@mui/icons-material";

import { useAuth } from "../../../hooks/auth";
import { useUsuariosOperativa } from "../../../hooks/useUsuariosOperativa";

import { MenuLateralUsuario } from "../MenuLateralUsuario";
import { FiltrosUsuarios } from "./components/FiltrosUsuarios";
import { TabelaUsuarios } from "./components/TabelaUsuarios";

export const ListaUsuario: React.FC = () => {
  const { user } = useAuth();

  const callerAcesso = user?.tipo_acesso.id_acesso ?? "0";
  const callerGrupo = user?.grupo ?? 0;
  const isMaster = callerAcesso === "2";

  const {
    filtros,
    data,
    meta,
    loading,
    iniciado,
    sistemasDisponiveis,
    atualizarFiltro,
    trocarPagina,
    trocarLimitePorPagina,
    trocarOrdenacao,
    limparFiltros,
  } = useUsuariosOperativa();

  const labelTotalRegistros = (() => {
    if (meta.total === 0) return "Sem registros";
    if (meta.total === 1) return "1 registro";
    return `${meta.total.toLocaleString("pt-BR")} registros`;
  })();

  return (
    <MUI.Stack flexDirection="row" width="100%" minHeight="80vh">
      <MenuLateralUsuario />

      <MUI.Stack gap={2} p={2} flex={1} overflow="hidden">
        {/* Cabeçalho */}
        <MUI.Stack direction="row" alignItems="center" gap={1}>
          <Icon.People color="primary" />
          <MUI.Typography variant="h6" fontWeight={600}>
            Usuários
          </MUI.Typography>
          {iniciado && (
            <MUI.Chip
              label={labelTotalRegistros}
              size="small"
              color="primary"
              variant="outlined"
              sx={{ "& .MuiChip-label": { px: "8px", py: "4px" } }}
            />
          )}
        </MUI.Stack>

        {/* Filtros */}
        <FiltrosUsuarios
          filtros={filtros}
          loading={loading}
          exibirFiltroBase={isMaster}
          sistemasDisponiveis={sistemasDisponiveis}
          onFiltroChange={atualizarFiltro}
          onLimpar={limparFiltros}
        />

        {/* Tabela com paginação */}
        <TabelaUsuarios
          data={data}
          meta={meta}
          filtros={filtros}
          loading={loading}
          iniciado={iniciado}
          callerAcesso={callerAcesso}
          callerGrupo={callerGrupo}
          onTrocarOrdenacao={trocarOrdenacao}
          onTrocarPagina={trocarPagina}
          onTrocarLimitePorPagina={trocarLimitePorPagina}
        />
      </MUI.Stack>
    </MUI.Stack>
  );
};
